import { EventType } from '@/stores/types';
import Events from '../index';

const Review = (): JSX.Element => {
  return <Events eventType={EventType.REVIEW} placeholder='Sorry, there are no events to show yet.' />;
};

export default Review;
